webpackJsonp([80],{

/***/ 1254:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1255);


/***/ }),

/***/ 1255:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(174);

var _datetime2 = _interopRequireDefault(_datetime);

var _de = __webpack_require__(771);

var _de2 = _interopRequireDefault(_de);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('de', _de2.default);

/***/ })

},[1254]);


// WEBPACK FOOTER //
// app/datetime.de-674ce9c0188aed4f1514.js